import {
  useApiMutation,
  useApiQuery,
  useLocalizedApiQuery,
} from "../services/react-query";

export const useGetSponsors = (params, queryOptions = {}) =>
  useLocalizedApiQuery({
    queryOptions: { queryKey: ["sponsors", params], ...queryOptions },
    fetchOptions: { url: "/sponsors", method: "GET", params },
  });
//public event sponsors
export const useGetPublicSponsors = (params) =>
  useLocalizedApiQuery({
    queryOptions: {
      queryKey: ["sponsors", "public", params],
      enabled: !!params.eventId,
    },
    fetchOptions: { url: "/public/sponsors", method: "GET", params },
  });

export const useGetSponsor = (id) =>
  useLocalizedApiQuery({
    queryOptions: { queryKey: ["sponsor", { id }], enabled: !!id },
    fetchOptions: { url: `/sponsors/${id}`, method: "GET" },
  });

export const usePatchSponsor = (id) =>
  useApiMutation({
    mutationOptions: { mutationKey: "patchSponsor" },
    fetchOptions: { url: `/sponsors/${id}`, method: "PATCH" },
    invalidateQueryKeys: [["sponsors"], ["sponsor"]],
    successMessage: { title: "Sponsor has been updated", color: "green" },
  });

export const useCreateSponsor = () =>
  useApiMutation({
    mutationOptions: { mutationKey: "useCreateSponsor" },
    fetchOptions: {
      url: "/sponsors",
      method: "POST",
    },
    invalidateQueryKeys: [["sponsors"]],
    successMessage: { title: "Sponsor has been created", color: "green" },
  });

export const useReorderSponsors = () =>
  useApiMutation({
    mutationOptions: { mutationKey: "reorderSponsors" },
    fetchOptions: { url: "/sponsors/order", method: "POST" },
    invalidateQueryKeys: [["sponsors"]],
    hideNotification: true,
  });

export const useDeleteSponsor = () =>
  useApiMutation({
    mutationOptions: { mutationKey: "useDeleteSponsor" },
    fetchOptions: { url: "/sponsors", method: "DELETE" },
    invalidateQueryKeys: [["sponsors"]],
    successMessage: { title: "Sponsor has been deleted", color: "green" },
  });

export const useGetSponsorLevels = (params) =>
  useLocalizedApiQuery({
    queryOptions: { queryKey: ["sponsorLevels"], enabled: !!params.eventId },
    fetchOptions: { url: `/sponsors/levels`, method: "GET", params },
  });

export const useGetPublicSponsorLevels = (params) =>
  useLocalizedApiQuery({
    queryOptions: {
      queryKey: ["sponsorLevels", "public"],
      enabled: !!params.eventId,
    },
    fetchOptions: { url: `/public/sponsors/levels`, method: "GET", params },
  });

export const usePatchSponsorLevels = () =>
  useApiMutation({
    mutationOptions: { mutationKey: "patchSponsorLevel" },
    fetchOptions: { url: `/sponsors/levels`, method: "POST" },
    invalidateQueryKeys: [["sponsorLevels"]],
    successMessage: {
      title: "Sponsor levels have been updated",
      color: "green",
    },
  });

export const useGetSponsorReps = (params) =>
  useApiQuery({
    queryOptions: { queryKey: ["sponsorReps"], enabled: !!params.eventId },
    fetchOptions: { url: `/sponsors/reps`, method: "GET", params },
  });
export const useGetPublicSponsorReps = (params) =>
  useApiQuery({
    queryOptions: {
      queryKey: ["sponsorReps", "public"],
      enabled: !!params.eventId,
    },
    fetchOptions: { url: `/public/sponsors/reps`, method: "GET", params },
  });
